export default {
  namespaced: true,
  state: {
    verId: null,
    sectionId: null,
    subSectionId: null,
    itemId: null,
    roughDiagId: null,
    solutionId: null,
    diagCourseId: null,
  },
  mutations: {
    SET_VER_ID(state, payload) {
      state.verId = payload;
    },
    SET_SECTION_ID(state, payload) {
      state.sectionId = payload;
    },
    SET_SUB_SECTION_ID(state, payload) {
      state.subSectionId = payload;
    },
    SET_ITEM_ID(state, payload) {
      state.itemId = payload;
    },
    SET_ROUGH_DIAG_ID(state, payload) {
      state.roughDiagId = payload;
    },
    SET_SOLUTION_ID(state, payload) {
      state.solutionId = payload;
    },
    SET_DIAG_COURSE_ID(state, payload) {
      state.diagCourseId = payload;
    },
    INIT(state) {
      state.verId = null;
      state.sectionId = null;
      state.subSectionId = null;
      state.itemId = null;
      state.roughDiagId = null;
      state.solutionId = null;
      state.diagCourseId = null;
    },
  },
  getters: {
    getVerId(state) {
      return state.verId;
    },
    getSectionId(state) {
      return state.sectionId;
    },
    getSubSectionId(state) {
      return state.subSectionId;
    },
    getItemId(state) {
      return state.itemId;
    },
    getRoughDiagId(state) {
      return state.roughDiagId;
    },
    getSolutionId(state) {
      return state.solutionId;
    },
    getDiagCourseId(state) {
      return state.diagCourseId;
    }
  },
  actions: {
    setVerId({commit}, payload) {
      commit('SET_VER_ID', payload);
    },
    setSectionId({commit}, payload) {
      commit('SET_SECTION_ID', payload);
    },
    setSubSectionId({commit}, payload) {
      commit('SET_SUB_SECTION_ID', payload);
    },
    setItemId({commit}, payload) {
      commit('SET_ITEM_ID', payload);
    },
    setRoughDiagId({commit}, payload) {
      commit('SET_ROUGH_DIAG_ID', payload);
    },
    setSolutionId({commit}, payload) {
      commit('SET_SOLUTION_ID', payload);
    },
    setDiagCourseId({commit}, payload) {
      commit('SET_DIAG_COURSE_ID', payload);
    },
    init({commit}) {
      commit('INIT');
    }
  }
}